import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { Box } from "@bca/ui-library";

import StyledIcon from "../Interfaces/StyledIcon";

const NoTransportSvg: React.FunctionComponent<StyledIcon> = ({
  fill = "primary-navy-blue",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors[fill] || fill;
  return (
    <Box {...props} color="black">
      <title>No Transport Icon</title>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5769 10.7999H18.0385C18.2692 10.7999 18.5 11.0314 18.5 11.2629V12.1888C18.5 12.4492 18.2692 12.6517 18.0385 12.6517H16.6538C16.6538 14.1853 15.4134 15.4294 13.8845 15.4294C12.3556 15.4294 11.1152 14.1853 11.1152 12.6517L7.88484 12.6149C7.88484 14.1484 6.64442 15.3926 5.11552 15.3926C3.58663 15.3926 2.34621 14.1484 2.34621 12.6149H1.88466C1.10579 12.6149 0.5 12.0073 0.5 11.226V1.96698C0.5 1.21468 1.10579 0.578125 1.88466 0.578125L10.6536 0.614979C11.4036 0.614979 12.0383 1.25154 12.0383 2.00383V3.39268H13.3076C13.6537 3.39268 14.0287 3.56629 14.2884 3.8267L17.1442 6.69121C17.4038 6.95162 17.5769 7.32777 17.5769 7.67499V10.7999ZM3.73087 12.6149C3.73087 13.3961 4.33665 14.0037 5.11552 14.0037C5.86555 14.0037 6.50018 13.3961 6.50018 12.6149C6.50018 11.8626 5.86555 11.226 5.11552 11.226C4.33665 11.226 3.73087 11.8626 3.73087 12.6149ZM12.4998 12.6517C12.4998 13.433 13.1056 14.0406 13.8845 14.0406C14.6345 14.0406 15.2691 13.433 15.2691 12.6517C15.2691 11.8994 14.6345 11.2629 13.8845 11.2629C13.1056 11.2629 12.4998 11.8994 12.4998 12.6517ZM12.0383 8.0222H16.1923V7.67499L13.3076 4.78154H12.0383V8.0222ZM7.09956 1.78815C8.67013 1.78815 9.93619 3.00726 9.93619 4.51957C9.93619 6.01645 8.67012 7.22012 7.11559 7.22012C6.92328 7.22012 6.74699 7.20469 6.58673 7.17382L6.2021 7.59048C6.12197 7.66764 6.02581 7.71393 5.91363 7.71393H5.32066V8.3312C5.32066 8.54725 5.14438 8.70156 4.93604 8.70156H4.29499V9.31883C4.29499 9.53488 4.1187 9.6892 3.91036 9.6892H2.11544C1.89107 9.6892 1.73081 9.53488 1.73081 9.31883V8.11516C1.73081 8.02257 1.76286 7.92998 1.84299 7.85282L4.4232 5.36831C4.34307 5.09054 4.29499 4.81277 4.29499 4.50414C4.29499 3.00726 5.54503 1.80358 7.09956 1.78815ZM7.88484 3.02269C7.45214 3.02269 7.11559 3.36219 7.11559 3.76341C7.11559 4.18007 7.45214 4.50414 7.88484 4.50414C8.30152 4.50414 8.6541 4.18007 8.6541 3.76341C8.6541 3.36219 8.30152 3.02269 7.88484 3.02269Z"
          fill={hexColor}
        />
      </svg>
    </Box>
  );
};

export default NoTransportSvg;
